import { ref, nextTick } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/common/bottom_left.png';
import _imports_1 from '@/assets/images/common/bottom_right.png';
const _withScopeId = n => (_pushScopeId("data-v-62fd97b2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "no_more_data"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 我有止境，探索无境 ", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_5 = [_hoisted_2, _hoisted_3, _hoisted_4];
export default /*#__PURE__*/_defineComponent({
  __name: 'noMoreData',
  props: {
    domId: {
      type: String,
      default: ''
    }
  },
  setup(__props) {
    const props = __props;
    const isShow = ref(false);
    const setShow = () => {
      nextTick(() => {
        if (!props.domId) return;
        const element = document.getElementById(props.domId);
        console.log(element.scrollHeight, element.clientHeight, 'nomoredata', element);
        if (element.scrollHeight > element.clientHeight) {
          setTimeout(() => {
            isShow.value = true;
          }, 500);
        }
      });
    };
    setShow();
    return (_ctx, _cache) => {
      return _unref(isShow) ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_5)) : _createCommentVNode("", true);
    };
  }
});